module.exports = __webpack_public_path__ + "assets/img/hero.acf354b5.jpg";